<script setup>
import { useAuth0 } from '@auth0/auth0-vue'
import ButtonComponent from '@/components/common/ButtonComponent.vue'

const { loginWithRedirect } = useAuth0()

defineProps({
  primary: Boolean
})

function onLogin() {
  loginWithRedirect({
    appState: {
      target: window.location.pathname
    }
  })
}
</script>
<template>
  <ButtonComponent primary @click="onLogin">
    Sign up / Sign in
  </ButtonComponent>
</template>
